import { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useLifeCycleEventBus } from '@thd-olt-functional/utils';

export const useQuickViewPipClickThroughEvent = (trackQuickViewPipClickThroughEvent) => {
  const quickViewPipClickThrough = useLifeCycleEventBus('quick-view.click-footer');
  useEffect(() => {
    if (!_isEmpty(quickViewPipClickThrough)) {
      const { productType } = quickViewPipClickThrough;
      trackQuickViewPipClickThroughEvent(productType);
    }
  }, [quickViewPipClickThrough]);
};
